import EFPicture from 'elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function A() {
    const { useLang } = useGlobal();
    const { t } = useLang('vanlife');
    return (
        <div className={`vanlife-A ${css['vanlife-A']}`}>
            <h1 className="title">{t('secA_title')}</h1>
            <div className="img-box">
                <EFPicture src={'/responsive/picture/vanlife/1.jpg'} alt={t('secA_title')} />
            </div>
            <p className="text">{t('secA_desc')}</p>
        </div>
    );
}
